import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Box } from 'roo-ui/components';
import OfferHighlighter from './OfferHighlighter';
import { getQueryFeaturedOfferId } from 'store/propertyAvailability/propertyAvailabilitySelectors';
import isNil from 'lodash/isNil';
import { useBreakpoints } from 'hooks/useBreakpoints';
import ExpandedOffer from './components/ExpandedOffer';
import OfferSummary from './components/OfferSummary';

const isHighlighted = (featuredId, offerId) => {
  if ([featuredId, offerId].some(isNil)) return false;
  return String(featuredId) === String(offerId);
};

const Offer = ({ roomTypeId, offer, counter, roomName, isLoading, ...rest }) => {
  const { isLessThanBreakpoint } = useBreakpoints();
  const isMobile = isLessThanBreakpoint(0);
  const [expanded, setExpanded] = useState(isMobile ? false : counter <= 1);
  const featuredOfferId = useSelector(getQueryFeaturedOfferId);
  const highlighted = isHighlighted(featuredOfferId, offer.id);
  const Highlight = highlighted ? OfferHighlighter : Fragment;

  useEffect(() => {
    if (setExpanded && isLoading) {
      setExpanded(isMobile ? false : counter <= 1);
    }
  }, [isMobile, counter, isLoading]);

  return (
    <Box {...rest}>
      <Highlight>
        {expanded ? (
          <ExpandedOffer roomTypeId={roomTypeId} offer={offer} roomName={roomName} toggleOfferExpanded={setExpanded} />
        ) : (
          <OfferSummary offer={offer} toggleOfferExpanded={setExpanded} mb={0} />
        )}
      </Highlight>
    </Box>
  );
};

Offer.propTypes = {
  offer: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    charges: PropTypes.object.isRequired,
    pointsEarned: PropTypes.object.isRequired,
    inclusions: PropTypes.array.isRequired,
    valueAdds: PropTypes.arrayOf(String),
    cancellationPolicy: PropTypes.object.isRequired,
    payableAtProperty: PropTypes.object,
    type: PropTypes.string.isRequired,
    depositPay: PropTypes.object.isRequired,
  }).isRequired,
  roomTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  counter: PropTypes.number.isRequired,
  roomName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default Offer;
